<template>
    <div id="app">
        <error-page v-if="loadErrorPage" />
        <div class="app" v-if="authentificated == true">
            <custom-header :logout="logoutHandler" :toggle="toggleSideMenuOnMobile" @contactPopupVisible="contactPopupVisible = true" :showRequestPartnersButton="showRequestPartnersButton"></custom-header>
            <sidebar
                :toggledOnMobile="sideMenuToggledOnMobile"
                @closeOverlay="sideMenuToggledOnMobile = false"
            ></sidebar>
            <div class="main">
                <div
                    class="overlay-for-menu-toggle"
                    v-show="sideMenuToggledOnMobile"
                    @click="sideMenuToggledOnMobile = false"
                ></div>
                <router-view :key="$route.fullPath"></router-view>
            </div>
        </div>
        <login 
        :logIn="logInHandler" 
        v-if="authentificated == false && !loadErrorPage"
        @change-brand="changeLoginBrand"
         
         @contactPopupVisible="contactPopupVisible = true" />

        <overlay :visible="contactPopupVisible">
            <popup
                class="contact-popup"
                :title="$t('CONTACT__CONTACT_US')"
                :contactForm="true"
                @close="contactPopupVisible = false"
            >
                <form class="contact-form" @submit.prevent="sendMessage">
                    <div>
                        <custom-input
                            :title="$t('CONTACT__EMAIL')"
                            v-model="contact.email"
                            inputType="email"
                            isRequired
                        ></custom-input>
                    </div>
                    <div class="mobile-section">
                        <div class="phone-code">
                            <custom-select
                                v-model="contact.phoneCode"
                                :options="countries"
                                isRequired
                            ></custom-select>
                        </div>
                        <div class="phone">
                            <custom-input
                                :title="$t('CONTACT__PHONE')"
                                v-model="contact.phone"
                                inputType="text"
                                isRequired
                            ></custom-input>
                        </div>
                    </div>
                    <div>
                        <custom-input
                            :title="$t('CONTACT__NAME')"
                            v-model="contact.name"
                            inputType="text"
                            isRequired
                        ></custom-input>
                    </div>
                    <div>
                        <textarea v-model="contact.message" cols="30" rows="10" :placeholder="$t('CONTACT__MESSAGE')"></textarea>
                    </div>
                    <button v-if="!contactSendSuccessfully" class="btn">{{$t(`CONTACT__SEND`)}}</button>
                    <p v-else class="success">{{$t(`CONTACT__THANK_YOU_FOR_CONTACTING_US`)}}</p>
                </form>
            </popup>
        </overlay>
    </div>
</template>

<script>
import Sidebar from './components/UI/Sidebar/Sidebar.vue'
import CustomHeader from './components/UI/Header/Header.vue'
import Login from '@/components/Login/Login.vue'
import axios from './Helpers/AxiosInstance'
import ErrorPage from './components/ErrorPage/ErrorPage.vue'
import Popup from './components/ReusableComponents/Popup/Popup.vue'
import Overlay from './components/ReusableComponents/Overlay/Overlay.vue'
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import CustomSelect from '@/components/ReusableComponents/CustomSelect/CustomSelect.vue'

export default {
    name: 'app',
    components: { Sidebar, CustomHeader, Login, ErrorPage, Popup, Overlay,CustomInput, CustomSelect },
    created() {
        var lastTimeActive = localStorage.getItem('lastTimeActive')
        this.contact.phoneCode = this.countries[0].value
        if(lastTimeActive) {
            if((Date.now() - lastTimeActive) / 1000 >= 5) {
                this.logoutHandler()
            }
        }

        axios
            .get('Profile/GetUserAuthStatus')
            .then(resp => {
                if (resp.data.auth) {
                    this.getNecessaryDataAndAuthentificate()
                } else {
                    this.authentificated = false
                    this.getTranslations()
                }
            })
            .catch(() => {
                this.loadErrorPage = true
            })
    },
    computed: {
        brandId() {
            return this.$store.state.shop && this.$store.state.shop.brandId
        },
        countries() {
            return this.$store.state.countryArr.filter(e=> e.PhoneCode).map(country => ({
                title: `+${country.PhoneCode} (${country.CountryCode})`,
                value: `+${country.PhoneCode}`
            })).sort((a,b) => a.value - b.value)
        }
    },
    data() {
        return {
            authentificated: null,
            sideMenuToggledOnMobile: false,
            loadErrorPage: false,
            contactPopupVisible: false,
            contactSendSuccessfully: false,
            showRequestPartnersButton:  false,
            loginBrandId: null,
            contact: {
                email: '',
                phoneCode: '',
                phone: '',
                name: '',
                message: '',
            },
        }
    },
    methods: {
        changeLoginBrand(brandId) {
            this.loginBrandId = brandId
        },
        logInHandler() {
            this.getNecessaryDataAndAuthentificate()
        },
        logoutHandler() {
            axios.post('Profile/LogOut')
            this.authentificated = false
        },
        getShopAndWebshops() {
            return axios.get('WebShop/GetUserShopAndWebShops').then(resp => {
                this.$store.state.webshops = resp.data.webShops
                this.$store.state.shop = resp.data.shop
                this.showRequestPartnersButton = this.$store.state.webshops.some(e=> ![3, 311].includes(e.shopId)) && this.$store.state.webshops != ''
            })
        },
        getDirectory() {
            return axios.get('WebShop/GetDirectory').then(resp => {
                this.$store.state.statusCodes = resp.data.statusCodes
                this.$store.state.countries = resp.data.countries
            })
        },
        getTranslations() {
            var language = localStorage.getItem('language') || 'en'
            return axios.get('WebShop/GetTranslations', {params: {'language': language}}).then(resp => {
                let translations = resp.data.translations
                let message = {}
                translations.forEach(tr => {
                    let groupName = resp.data.translationGroups.filter(el => el.id == tr.groupId)[0].name
                    let keyName = resp.data.translationKeys.filter(el => el.id == tr.keyId)[0].name
                    message[groupName+'__'+keyName] = tr['text']
                })
                this.$i18n.setLocaleMessage(language, message)
                this.$i18n.locale = language
            })
        },
        toggleSideMenuOnMobile() {
            this.sideMenuToggledOnMobile = !this.sideMenuToggledOnMobile
        },
        getNecessaryDataAndAuthentificate() {
            Promise.all([this.getDirectory(), this.getShopAndWebshops(), this.getTranslations()]).then(
                () => {
                    this.authentificated = true
                    localStorage.setItem('lastTimeActive', Date.now())
                    setInterval(() => {
                        localStorage.setItem('lastTimeActive', Date.now())
                    }, 1000);
                } 
            )
        },
        sendMessage() {
          axios
          .post('/WebShop/SendContactNotification', {
              ...this.contact,
              brandId: this.brandId || this.loginBrandId,
              typeId: 5
          })
          .then(resp=> {
               if(resp.data.status == 1) {
                    this.contactSendSuccessfully = true

                    this.contact.email = ''
                    this.contact.phone = ''
                    this.contact.phoneCode = ''
                    this.contact.name = ''
                    this.contact.message = ''

                    setTimeout(() => {
                        this.contactPopupVisible = false
                        this.contactSendSuccessfully = false
                    }, 2500);
                }
          })
        },
    },
    watch: {
        sideMenuToggledOnMobile(toggled) {
            if (toggled) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = 'initial'
            }
        },
    },
}
</script>

<style lang="scss">
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: Roboto;
}

.main {
    background-color: $background;
    width: calc(100% - 250 *#{$rem});
    margin-left: 250 * $rem;
    margin-top: 61 * $rem;
    padding: 15 * $rem;
    min-height: calc(100vh - 74 *#{$rem});
    transition: all 0.3s ease-out;
    position: relative;

    &.expand {
        margin-left: 0;
        width: 100%;
    }

    .overlay-for-menu-toggle {
        position: fixed;
        top: 60 * $rem;
        left: 0;
        width: 100%;
        height: calc(100% - 60 *#{$rem});
        background-color: rgba(0, 0, 0, 0.3);
        cursor: pointer;
        z-index: 20;
    }
}


textarea {
    border-radius: 0.3125rem;
    box-shadow: none;
    border: 0.0625rem solid #b4b4b4;
    color: #474747;
    font-size: 0.9375rem;
    padding-left: 0.9375rem;
    padding-top: 0.9375rem;
    outline: none;
}

.btn {
background-color: $green-main;
box-shadow: none;
border: none;
height: 100%;
color: white;
width: 72 * $rem;
align-items: center;
font-size: 15 * $rem;
border-radius: 5 * $rem;
cursor: pointer;
min-height: 40 * $rem;
min-width: 115 * $rem;

    &:hover {
        filter: brightness(1.1);
    }
}

.btn-filter {
    background-color: rgb(167, 167, 167);
}

.btn-red {
    background-color: $red;
}

.general-input {
    height: 100%;
    border-radius: 5 * $rem;
    padding-left: 11 * $rem;
    border: $rem solid #e3e4eb;
    color: #707070;
    font-size: 14 * $rem;
    font-weight: 500;
    outline-color: $green-main;

    &::placeholder {
        color: #bbbbbb;
    }
}

.link {
    text-decoration: none;
    color: #4466ff;
}

.switcher {
    width: 34 * $rem;
    height: 18 * $rem;
    background-color: #adadad;
    border-radius: 15 * $rem;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:after {
        position: absolute;
        content: '';
        left: 4 * $rem;
        bottom: 0;
        top: 0;
        margin: auto;
        width: 10 * $rem;
        height: 10 * $rem;
        border-radius: 50%;
        background-color: white;
        transition: all 0.3s ease-out;
    }

    &.active {
        background-color: #ff2828;
        &:after {
            left: 20 * $rem;
        }
    }
}

.main-form {
    flex-wrap: wrap;
    margin-top: -25 * $rem;

    label,
    .select-wrapper,
    .checkbox-wrapper,
    .switcher-container,
    .btn {
        margin-top: 25 * $rem;
        width: calc(20% - #{15 * $rem}) !important;
        margin-right: 15 * $rem;

        &:last-child {
            margin-right: 0;
        }
    }
}

//loader
.loader,
.loader:before,
.loader:after {
    background: black;
    -webkit-animation: load1 1s infinite ease-in-out;
    animation: load1 1s infinite ease-in-out;
    width: 1em;
    height: 4em;
}
.loader {
    color: black;
    text-indent: -9999em;
    margin: 88px auto;
    position: relative;
    font-size: 11px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}
.loader:before,
.loader:after {
    position: absolute;
    top: 0;
    content: '';
}
.loader:before {
    left: -1.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}
.loader:after {
    left: 1.5em;
}
@-webkit-keyframes load1 {
    0%,
    80%,
    100% {
        box-shadow: 0 0;
        height: 4em;
    }
    40% {
        box-shadow: 0 -2em;
        height: 5em;
    }
}
@keyframes load1 {
    0%,
    80%,
    100% {
        box-shadow: 0 0;
        height: 4em;
    }
    40% {
        box-shadow: 0 -2em;
        height: 5em;
    }
}

@media only screen and (max-width: 1024px) {
    .main {
        margin-left: 0;
        width: 100%;
    }

    .main-form {
        label,
        .select-wrapper,
        .checkbox-wrapper,
        .switcher-container,
        .btn {
            width: calc(33% - #{20 * $rem}) !important;
        }
    }
}

@media only screen and (max-width: 667px) {
    html {
        font-size: 14 * $rem;
    }
}

@media only screen and (max-width: 585px) {
    html {
        font-size: 13 * $rem;
    }

    .main-form {
        label,
        .select-wrapper,
        .checkbox-wrapper,
        .switcher-container,
        .btn {
            width: calc(50% - #{15 * $rem}) !important;
        }
    }
}

@media only screen and (max-width: 350px) {
    .main-form {
        label,
        .select-wrapper,
        .checkbox-wrapper,
        .switcher-container,
        .btn {
            width: calc(100% - #{15 * $rem}) !important;
        }
    }
}
</style>
